import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Box, Fade, useTheme } from "@material-ui/core";
import { UserContext } from "contexts/UserContext";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction"; // for selectable
import "@fullcalendar/core/main.css";
import "@fullcalendar/daygrid/main.css";
import "./Calendar.scss";

const brightness = (color) => {
  const hasFullSpec = color.length === 7;
  var m = color.substr(1).match(hasFullSpec ? /(\S{2})/g : /(\S{1})/g);
  if (m) {
    const r = parseInt(m[0] + (hasFullSpec ? "" : m[0]), 16);
    const g = parseInt(m[1] + (hasFullSpec ? "" : m[1]), 16);
    const b = parseInt(m[2] + (hasFullSpec ? "" : m[2]), 16);

    return (r + g + b) / 3;
  }
  return 0;
};

export default (props) => {
  //const [selectInfo, setSelectInfo] = React.useState({});
  const theme = useTheme();
  const themeBackgroundColor = theme.palette.background.default;
  const userContext = React.useContext(UserContext);
  const history = useHistory();
  const location = useLocation();
  // Only leaders can actually create events (server-enforced) - showing
  // the button to everyone else just means a confusing "not allowed"
  // error when they tap it.
  const isTeamLeader = userContext.user.is_team_leader;

  return (
    <div
      className={
        brightness(themeBackgroundColor) < 100
          ? "calendar dark"
          : "calendar light"
      }
    >
      <Fade in={true} timeout={1000}>
        <Box className="calendarWrapper">
          <FullCalendar
            defaultView="dayGridMonth"
            plugins={[interactionPlugin, dayGridPlugin]}
            // Selecting a date range only exists to feed the "+" button
            // above (pre-fills the new event's start/end) - pointless
            // to leave switched on for someone who can't create events.
            selectable={isTeamLeader}
            // FullCalendar defaults to requiring a ~1s long-press before
            // it interprets a touch as a date selection (so it doesn't
            // fight with normal page scrolling) - a plain tap did
            // nothing. 0 means no hold at all - a single tap selects
            // immediately, same as a click already does on desktop.
            selectLongPressDelay={0}
            height="parent"
            events={props.events}
            firstDay={1}
            /*select={function(info) {
              setSelectInfo(info);
            }}*/
            header={{
              left: "title",
              center: "none",
              right: isTeamLeader ? "add, prev, next" : "prev, next",
            }}
            fixedWeekCount={false}
            timeFormat="HH:mm"
            timeZone="UTC"
            eventTimeFormat={{
              hour: "2-digit",
              minute: "2-digit",
              hour12: false,
              omitZeroMinute: false,
              meridiem: false,
            }}
            eventClick={(info) => {
              // Event detail is its own full page now, not a modal
              // over the grid - see /events/:id.
              history.push(
                `/events/${info.event.extendedProps.id}`,
                { from: location }
              );
            }}
            select={(info) => {
              props.goToNewEvent(info);
            }}
            customButtons={{
              add: {
                icon: "add",
                click: function (event) {
                  event.preventDefault();
                  props.goToNewEvent();
                },
              },
            }}
          />
        </Box>
      </Fade>
    </div>
  );
};
